import { useState } from 'react';

function useLocalStorage(key: string, defaultValue: boolean): [boolean, (value: boolean) => void];
function useLocalStorage(key: string, defaultValue: string): [string, (value: string) => void];
function useLocalStorage(key: string, defaultValue: string | boolean) {
  if (typeof defaultValue === 'boolean') {
    return useStorage(window.localStorage, key, defaultValue);
  }
  return useStorage(window.localStorage, key, defaultValue);
}

function useSessionStorage(key: string, defaultValue: boolean): [boolean, (value: boolean) => void];
function useSessionStorage(key: string, defaultValue: string): [string, (value: string) => void];
function useSessionStorage(key: string, defaultValue: string | boolean) {
  if (typeof defaultValue === 'boolean') {
    return useStorage(window.sessionStorage, key, defaultValue);
  }
  return useStorage(window.sessionStorage, key, defaultValue);
}

function useStorage(storage: Storage, key: string, defaultValue: boolean): [boolean, (value: boolean) => void];
function useStorage(storage: Storage, key: string, defaultValue: string): [string, (value: string) => void];
function useStorage(storage: Storage, key: string, defaultValue: string | boolean) {
  let getInitialValue = () => storage.getItem(key) ?? defaultValue;
  if (typeof defaultValue === 'boolean') {
    getInitialValue = () => JSON.parse(storage.getItem(key) || 'null') ?? defaultValue;
  }
  const setItem = (newValue: string | boolean) => {
    if (typeof newValue === 'boolean') {
      newValue = JSON.stringify(newValue);
    }
    setValue(newValue);
    storage.setItem(key, newValue);
  };
  const [value, setValue] = useState(getInitialValue);
  if (typeof defaultValue === 'boolean') {
    return [value, setItem] as [boolean, (value: boolean) => void];
  }
  return [value, setItem] as [string, (value: string) => void];
}

function useUserDataState(key: 'authorization', defaultValue: boolean): [boolean, (value: boolean) => void];
function useUserDataState(key: 'login' | 'passwd', defaultValue: string): [string, (value: string) => void];
function useUserDataState(key: 'login' | 'authorization' | 'passwd', defaultValue: string | boolean) {
  return key === 'authorization' ? useSessionStorage(key, defaultValue as boolean) : useLocalStorage(key, defaultValue as string);
}

const getAuthorizationState = () => {
  return JSON.parse(window.sessionStorage.getItem('authorization') || 'false');
};

export { useUserDataState, getAuthorizationState };
